import * as React from 'react';
import C from 'classnames';
export const CardHeaderTitle = props => {
    return (React.createElement("h4", { className: C('card-header-title', props.muted && 'text-muted', props.className) }, props.children));
};
//# sourceMappingURL=CardHeaderTitle.js.map